import { render, staticRenderFns } from "./SDS-dataPoint-widget.vue?vue&type=template&id=ec8d6d88"
import script from "./SDS-dataPoint-widget.vue?vue&type=script&lang=js"
export * from "./SDS-dataPoint-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports